module.exports = __webpack_public_path__ + "files/e9f4f3e45220eee8eca0f98874b81f46.png";